import { render } from "./StockWithdrawalDetailsView.vue?vue&type=template&id=4db92b3e&scoped=true"
import script from "./StockWithdrawalDetailsView.vue?vue&type=script&lang=js"
export * from "./StockWithdrawalDetailsView.vue?vue&type=script&lang=js"

import "./StockWithdrawalDetailsView.vue?vue&type=style&index=0&id=4db92b3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db92b3e"]])

export default __exports__